/** Bump a tour's version only when everyone should see its revised introduction. */
export function tourCompletedKey(tourId: string, version = 1): string {
  return `onboarding_tour_${tourId}_v${version}`;
}

export const ONBOARDING_Z_INDEX = 80;
export const ONBOARDING_DESKTOP_QUERY = '(min-width: 1024px)';
export const DEFAULT_SPOTLIGHT_PADDING = 8;
export const DEFAULT_SPOTLIGHT_RADIUS = 16;
